<template>
  <div class="page-container" v-cloak>
    <UiToastList/>
    <IdleModal v-if="$root.isIdle" />
    <div class="full-height-container h-full sm:h-full md:h-screen">
      <MobileHeader></MobileHeader>
      <div class="flex" style="overflow-x:hidden; height: 100%">
        <Sidebar></Sidebar>
        <!-- ... -->
        <div class="main-container">
          <!-- Turn off absolute-style to other page-->
          <MainHeader></MainHeader>
          <div class="loan-banner" v-if="displayTopBanner">
            <h1 style="color: #CC2631">Chào mừng Quý khách
              <br />
            {{$store.state.user.currentUser.FullName}}
            </h1>
          </div>

          <div class="payment-banner" v-if="displayPaymentTopBanner">
            <!--<h1>Thanh toán trực tuyến</h1>-->
          </div>

          <transition name="fade">
            <router-view></router-view>
          </transition>

        </div>
      </div>
    </div>
    <ModalRoot/>
  </div>
</template>

<script>
import MobileHeader from './MobileHeader.vue'
import MainHeader from './MainHeader.vue'
import Sidebar from './Sidebar.vue'
import UiToastList from '@/components/UiToastList'
import ModalRoot from '@/components/ModalRoot'
import IdleModal from '@/components/IdleModal'

export default {
  name: 'AppLayout',
  components: {
    Sidebar,
    MobileHeader,
    MainHeader,
    UiToastList,
    ModalRoot,
    IdleModal
  },
  data () {
    return {
      displayPaymentTopBanner: false,
      displayTopBanner: false
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (newVal, oldVal) {
        if (this.$route.path === '/loan') {
          this.displayTopBanner = true
        } else {
          this.displayTopBanner = false
        }

        if (this.$route.path === '/payment') {
          this.displayPaymentTopBanner = true
        } else {
          this.displayPaymentTopBanner = false
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
  @import '../assets/css/normalize.css';
  @import '../assets/css/main.css';
  @import '../assets/css/tailwind.min.css';
  @import '../assets/css/styles.css';
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
  @import '../assets/css/fontello.css';
</style>
